import type { RoleWithPermissions } from "@mc/types"

/** Small color-coded chip for a role, reused anywhere a role needs to be
 *  named inline (member rows, family member rows). Color always comes
 *  from the role's own `color` field (FR section 3), never a fixed
 *  palette pick — that's the whole point of letting roles have a color. */
export function RoleBadge({ role }: { role: Pick<RoleWithPermissions, "name" | "color"> | null }) {
  if (!role) {
    return <span style={{ fontSize: "var(--text-xs)", color: "var(--text-muted)" }}>Sin rol</span>
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "var(--space-2)",
        fontSize: "var(--text-xs)",
        fontWeight: "var(--font-weight-medium)",
        padding: "2px var(--space-2)",
        borderRadius: "var(--radius-full)",
        border: `1px solid ${role.color}`,
        color: role.color,
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: "var(--radius-full)", background: role.color }} />
      {role.name}
    </span>
  )
}
